// 审核状态处理
export function reviewState(state) {
	let stateName = "";
	if (state === 0) {
		stateName = "未送审";
	} else if (state === 1) {
		stateName = "审核中";
	} else if (state === 2) {
		stateName = "已审核";
	} else if (state === 3) {
		stateName = "已驳回";
	}
	return stateName;
}

// 审核状态颜色处理
export function reviewStateColor(state) {
	let color = "";
	if (state === 0) {
		color = "#adadad";
	} else if (state === 1) {
		color = "#55aaff";
	} else if (state === 2) {
		color = "#3eba5b";
	} else if (state === 3) {
		color = "#ffff7f";
	}
	return color;
}

export function handleTaskState(subTaskState) {
	let subTaskStateName = "";
	if (subTaskState === 0) {
		subTaskStateName = "待激活";
	} else if (subTaskState === 1) {
		subTaskStateName = "初始";
	} else if (subTaskState === 2) {
		subTaskStateName = "待执行";
	} else if (subTaskState === 3) {
		subTaskStateName = "执行中";
	} else if (subTaskState === 4) {
		subTaskStateName = "已暂停";
	} else if (subTaskState === 5) {
		subTaskStateName = "已报工";
	}
	return subTaskStateName;
}

export function cssStringToObject(cssString) {
	// 移除字符串两端的空白字符
	cssString = cssString.trim();

	// 假设CSS样式以花括号包围，并且属性之间以分号分隔
	// 这里我们简单地通过分号分割字符串，然后进一步处理每个属性
	const properties = cssString.slice(1, -1).split(";"); // 移除最外层的花括号

	// 创建一个空对象来存储CSS属性
	const cssObject = {};

	// 遍历每个属性，并添加到对象中
	properties.forEach((property) => {
		if (property.trim() !== "") {
			// 忽略空字符串
			const [key, value] = property.trim().split(":"); // 通过冒号分割键和值
			cssObject[key.trim()] = value.trim(); // 添加到对象中，同时移除键和值两端的空白字符
		}
	});

	// 返回JavaScript对象，或者如果需要，可以返回JSON字符串
	// return cssObject; // 返回JavaScript对象
	return JSON.stringify(cssObject, null, 2); // 返回格式化的JSON字符串
}
